export default __webpack_public_path__ + "00a077ee7b11a240b4b6ff6af985abd2.md";